export default "__VITE_ASSET__bf26d847__"